<template>
    <div class="container new-project-create">
        <div class="row">
            <div class="col-md-12 mt-5 mb-2">
                <div class="card shadow">
                    <div class="card-header border-0">
                        <h3 v-if="addProject" class="mb-0 text-center">Add Project</h3>
                        <h3 v-if="!addProject" class="mb-0 text-center">Update Project</h3>
                    </div>
                    <div class="card-body">
                        <form role="form">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group mb-3">
                                        <label for="project_title">Project Title</label>
                                        <input type="text" v-model="projects.project_title" class="form-control"
                                               id="project_title">
                                    </div>
                                </div>
                                <!--<div class="col-md-6">-->
                                <!--<div class="form-group mb-3">-->
                                <!--<label for="project_url">Project URL</label>-->
                                <!--<input type="text" v-model="projects.project_url" class="form-control"-->
                                <!--id="project_url">-->
                                <!--</div>-->
                                <!--</div>-->
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group mb-3">
                                        <label for="project_date">Project Date</label>
                                        <!--<input type="text" class="form-control" id="project_date">-->
                                        <base-input addon-left-icon="ni ni-calendar-grid-58">
                                            <flat-picker slot-scope="{focus, blur}"
                                                         @on-open="focus"
                                                         @on-close="blur"
                                                         :config="{allowInput: true}"
                                                         class="form-control datepicker"
                                                         v-model="projects.project_date"
                                                         id="project_date">
                                            </flat-picker>
                                        </base-input>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group mb-3">
                                        <label for="project_end_date">project End Date</label>
                                        <!--<input type="text" class="form-control" id="project_end_date">-->
                                        <base-input addon-left-icon="ni ni-calendar-grid-58">
                                            <flat-picker slot-scope="{focus, blur}"
                                                         @on-open="focus"
                                                         @on-close="blur"
                                                         :config="{allowInput: true}"
                                                         class="form-control datepicker"
                                                         v-model="projects.project_date_registration_end"
                                                         id="project_end_date">
                                            </flat-picker>
                                        </base-input>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group mb-3">
                                        <label for="project_date">Project Next Date</label>
                                        <base-input addon-left-icon="ni ni-calendar-grid-58">
                                            <flat-picker slot-scope="{focus, blur}"
                                                         @on-open="focus"
                                                         @on-close="blur"
                                                         :config="{allowInput: true}"
                                                         class="form-control datepicker"
                                                         v-model="projects.project_date_registration_next"
                                                         id="project_next_date">
                                            </flat-picker>
                                        </base-input>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group mb-3">
                                        <label for="project_fees">Project Fees</label>
                                        <input type="text" v-model="projects.project_fee" class="form-control"
                                               id="project_fees">
                                    </div>
                                </div>
                            </div>

                            <div class="form-group mb-3">
                                <label>Project Description</label>
                                <editor v-model="projects.project_description" v-validate="'required|min:16'"
                                        name="event_description"
                                        api-key="API_KEY" :init="{plugins: 'wordcount'}"
                                        data-vv-as="event description"></editor>
                                <small v-if="errors.has('projects.project_description')" class="text-danger">
                                    {{ errors.first('event_description') }}
                                </small>
                            </div>
                            <div class="form-group mb-3">
                                <label>How It Works</label>
                                <editor v-model="projects.project_how_it_works" v-validate="'required|min:16'"
                                        name="project_how_it_works"
                                        api-key="API_KEY" :init="{plugins: 'wordcount'}"
                                        data-vv-as="How It Works"></editor>
                                <small v-if="errors.has('project_how_it_works')" class="text-danger">
                                    {{ errors.first('project_how_it_works') }}
                                </small>
                            </div>
                            <div class="form-group mb-3">
                                <label>Project Venue</label>
                                <editor v-model="projects.project_venue" v-validate="'required|min:16'"
                                        name="project_venue"
                                        api-key="API_KEY" :init="{plugins: 'wordcount'}"
                                        data-vv-as="Project Venue"></editor>
                                <small v-if="errors.has('projects.project_venue')" class="text-danger">
                                    {{ errors.first('project_venue') }}
                                </small>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group mb-3">
                                        <label for="project_city">Project City</label>
                                        <input type="text" v-model="projects.project_city" class="form-control"
                                               id="project_city">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group mb-3">
                                        <label for="project_location">Project location</label>
                                        <input type="text" v-model="projects.project_location" class="form-control"
                                               id="project_location">
                                    </div>
                                </div>
                            </div>
                            <div>
                                <button v-if="addProject" type="button" @click="add_projects()"
                                        class="btn my-4 btn-primary">
                                    <i :class="{'loader': loading}"></i> <span v-if="!loading">Create Project</span>
                                </button>
                                <button v-if="!addProject" type="button" @click="update_projects()"
                                        class="btn my-4 btn-primary">
                                    <i :class="{'loader': loading}"></i> <span v-if="!loading">Update Project</span>
                                </button>
                                <router-link :to="{name: 'website-project'}" class="btn btn-secondary">Back
                                </router-link>
                            </div>
                        </form>
                        <hr class="my-3">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import vueHeadful from "vue-headful";
import Editor from "@tinymce/tinymce-vue";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import axios from "axios";

export default {
  data() {
    return {
      projects: {},
      loading: false,
      addProject: true
    };
  },
  methods: {
    add_projects: function() {
      this.projects.access_token = localStorage.getItem("access_token");
      this.loading = true;

      axios({
        method: "POST",
        url: "admin/projects/new",
        data: this.projects,
        headers: {
          "content-type": "application/json"
        }
      }).then(
        result => {
          if (result.data.status === true) {
            this.loading = false;
            this.projects = {};
            this.$swal("Project has been added successfully!", "", "success");
          }
        },
        error => {
          this.loading = false;
          this.$swal("Something went wrong Please try again!", "", "error");
          error;
        }
      );
    },
    update_projects: function() {
      this.projects.access_token = localStorage.getItem("access_token");
      this.loading = true;

      axios({
        method: "PUT",
        url: "admin/projects/update/" + this.$route.params.pr_id,
        data: this.projects,
        headers: {
          "content-type": "application/json"
        }
      }).then(
        result => {
          if (result.data.status === true) {
            this.loading = false;
            this.projects = {};
            this.$swal("Project has been updated successfully!", "", "success");
          }
        },
        error => {
          this.loading = false;
          this.$swal("Something went wrong Please try again!", "", "error");
          error;
        }
      );
    },
    getSingleProject: function(pr_id) {
      axios({
        url:
          "admin/projects/" +
          pr_id +
          "?access_token=" +
          localStorage.getItem("access_token"),
        method: "get",
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(
          result => {
            this.projects = result.data.project;
          },
          error => {
            console.log(error.response);
          }
        )
        .catch(e => {
          console.log(e);
        });
    }
  },
  components: {
    "vue-headful": vueHeadful,
    editor: Editor,
    flatPicker
  },
  mounted: function() {
    if (this.$route.params.pr_id > 0) {
      this.getSingleProject(this.$route.params.pr_id);
      this.addProject = false;
    } else {
      this.projects = {};
      this.addProject = true;
    }
  }
};
</script>
<style lang="scss">
.new-project-create {
  label {
    color: #000000;
  }
}
</style>
